export default "__VITE_ASSET__3617b1fc__"